/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Files_Filters_ProviderInputs */

const es_settings_files_filters_provider = /** @type {(inputs: Settings_Files_Filters_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proveedor`)
};

const en_settings_files_filters_provider = /** @type {(inputs: Settings_Files_Filters_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provider`)
};

/**
* | output |
* | --- |
* | "Provider" |
*
* @param {Settings_Files_Filters_ProviderInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_files_filters_provider = /** @type {((inputs?: Settings_Files_Filters_ProviderInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Files_Filters_ProviderInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_files_filters_provider(inputs)
	return en_settings_files_filters_provider(inputs)
});
export { settings_files_filters_provider as "settings.files.filters.provider" }